<template>
  <div>
    <card-collapsable
      headerClass="cyan darken-1 white--text"
      dialogClass="auctioneer"
      :dialogProp="dialog"
    >
      <!-- always visible -->
      <template #visible>
        <v-icon class="white--text">gavel</v-icon>
      </template>

      <!-- card-title -->
      <template #title> Estrazione casuale </template>

      <!-- card-body-->
      <template #body>
        <div>
          <!-- si sta facendo asta per -->
          <si-sta-facendo-asta-per></si-sta-facendo-asta-per>

          <!-- ruoli random -->
          <div class="chooser_random">
            <div class="random-options text-center">
              <!-- classic -->
              <div v-if="classic" class="cal-ruoli px-4 pt-4">
                <!-- :disabled="disabledRuolo(ruolo_id)"
               :style="{
                  opacity: disabledRuolo(ruolo_id) ? 0.3 : 1,
                }"-->
                <v-btn
                  v-for="ruolo_id in ruoli_da_chiamare"
                  :key="ruolo_id"
                  depressed
                  icon
                  class="ma-2"
                  @click="estraiDaRuolo(ruolo_id)"
                >
                  <span
                    class="Ruolo outline"
                    :class="{
                      ['Ruolo_' + ruolo_id]: true,
                    }"
                    >{{ Constants.RUOLI_NEW[ruolo_id].abc }}</span
                  >
                </v-btn>
                <!-- info -->
                <!-- <v-icon color="text" small @click="showDialogInformazioni"
                >info</v-icon
              > -->
              </div>
              <!-- mantra -->
              <div v-else class="my-4">
                <!-- :class="{
                  ['ruolo-mantra' + mantra_id]: true,
                  disalibitato: disabledRuoloMantra(mantra_id),
                }"
                :disabled="disabledRuoloMantra(mantra_id)" -->
                <span
                  v-for="(mantraObj, mantra_id) in Constants.RUOLI_MANTRA"
                  :key="mantra_id"
                  @click="selectRuoloMantra(mantra_id)"
                  class="ruolo-mantra"
                  :class="{
                    ['ruolo-mantra' + mantra_id]: true,
                  }"
                  >{{ ruoloMantra(mantra_id) }}</span
                >
              </div>
              <!-- ruolo a caso -->
              <div
                v-if="
                  ruolo_da_chiamare == Constants.RUOLO_DA_CHIAMARE.QUALUNQUE
                "
                class="pb-4"
              >
                <div class="pb-2">oppure</div>
                <v-btn
                  depressed
                  rounded
                  class="cyan white--text"
                  @click="estraiDaRuolo(0)"
                  >Ruolo a caso
                </v-btn>
              </div>
            </div>
          </div>

          <!-- scartati -->
          <div class="text-center pb-2 px-2">
            (Clicca sul ruolo che vuoi estrarre)
          </div>
          <div class="text-right pb-2 px-2">
            <a href="#" @click.prevent="manageScartati" class="text--text"
              >Gestione Scartati</a
            >
            <!-- Gestione Scartati
            <v-btn
              outlined
              depressed
              x-small
              rounded
              icon
              @click="manageScartati"
            >
              <v-icon x-small>edit</v-icon>
            </v-btn> -->
          </div>
        </div>
      </template>

      <!-- <v-dialog eager v-model="dialog" persistent hide-overlay max-width="350">
      </v-dialog> -->

      <!-- card-actions -->
      <template #actions v-if="showPasso">
        <v-card-actions class="justify-end">
          <v-btn depressed rounded @click="passo()" class="cyan white--text">
            <v-icon small left>airline_stops</v-icon> Passa
          </v-btn>
        </v-card-actions>
      </template>
    </card-collapsable>

    <!-- <v-dialog v-model="dialogInformazioni" max-width="350">
      <v-card>
        <v-card-title class="navy white--text">
          <v-icon class="white--text" left>info</v-icon>
          Ricorda
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="white--text"
            light
            icon
            @click="dismissDialogInformazioni"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <div class="white">
          <div class="pa-4">
            Se il ruolo non dovesse essere cliccabile è perchè ne sono terminati
            gli svincolati. Se vuoi riabilitare calciatori scartati clicca su
            "Gestione Scartati"
          </div>
        </div>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";

import SiStaFacendoAstaPer from "../common/SiStaFacendoAstaPer";
import CardCollapsable from "../common/CardCollapsable";
import mixins from "../../js/mixins";
import toast from "../../js/toast";

import Vuex from "vuex";

//////////////////////////////////////////////////
// random => no offerta contestuale (offerta_auto)
//////////////////////////////////////////////////

export default {
  name: "asta-auctioneer-random",
  mixins: [mixins, toast],
  components: { CardCollapsable, SiStaFacendoAstaPer },
  data() {
    return {
      dialogInformazioni: false,
    };
  },
  props: {
    selected: {
      type: Function,
      default: function () {},
    },
  },
  mounted() {
    console.log("--> AstaAuctioneerRandom ready.");
  },
  destroyed() {
    console.log("<-- AstaAuctioneerRandom destroyed.");
  },
  methods: {
    // showDialogInformazioni() {
    //   this.dialogInformazioni = true;
    // },
    // dismissDialogInformazioni() {
    //   this.dialogInformazioni = false;
    // },
    manageScartati() {
      db.emit("manageScartati");
    },
    passo() {
      const next_squadra_id = Helpers.findNextSquadraIdAsChooser(
        this.asta_choosers,
        this.user_uid
      );
      if (next_squadra_id) {
        db.setChooser(next_squadra_id);
      }
    },
    selectCalciatore: function (id) {
      if (id) {
        // salva calciatoreInAsta su db
        let promise = db
          .setCalciatoreInAsta(id)
          .then(this.astaLogCalciatoreInAsta(id, this.user_uid));
        if (this.mode_poker || this.mode_selvaggia || this.mode_bustachiusa) {
          let asta_mode = this.asta_settings.mode;
          promise.then(db.initRound(id, asta_mode)).then(() => {
            if (this.mode_bustachiusa) {
              db.setStep({ type: Constants.ROUND_STEP.OFFERTE });
            }
          });
        }
      }
    },
    estraiDaRuolo(ruolo_id) {
      // se passo 0 lo seleziono tra tutti i ruoli
      const selected_id = _.sample(this.svincolati(ruolo_id, ""));
      if (selected_id) {
        this.selectCalciatore(selected_id);
      } else {
        let testo =
          ruolo_id == 0
            ? "Nessun svincolato rimasto libero."
            : "Nessun svincolato rimasto libero nel ruolo selezionato.";
        testo =
          testo +
          '<br><br>Potresti voler riabilitare degli svincolati scartati in "Gestione scartati"';
        Swal.fire({
          icon: "warning",
          html: testo,
        });
        // this.errorToast("Errore", "Nessun calciatore selezionato");
      }
    },
    selectRuoloMantra(mantra_id) {
      const selected_id = _.sample(
        this.svincolati(0, "", 0, false, [], [mantra_id])
      );
      if (selected_id) {
        this.selectCalciatore(selected_id);
      } else {
        let testo =
          ruolo_id == 0
            ? "Nessun svincolato rimasto libero."
            : "Nessun svincolato rimasto libero nel ruolo selezionato.";
        testo =
          testo +
          '<br><br>Potresti voler riabilitare degli svincolati scartati in "Gestione scartati"';
        Swal.fire({
          icon: "warning",
          html: testo,
        });
        // this.errorToast("Errore", "Nessun calciatore selezionato");
      }
    },
    // disabledRuolo(ruolo_id) {
    //   if (
    //     _.size(this.svincolati(ruolo_id, "")) === 0
    //     // || this.ruoli_da_chiamare.indexOf(ruolo_id) === -1
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    // disabledRuoloMantra(mantra_id) {
    //   if (
    //     _.size(this.svincolati(0, "", 0, false, [], [mantra_id])) === 0
    //     // || this.ruoli_da_chiamare.indexOf(ruolo_id) === -1
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    squadra(id) {
      return this.asta_squadre[id];
    },
  },
  computed: {
    dialog() {
      return this.staScegliendo(this.user_uid);
    },
    ruolo_da_chiamare() {
      return this.asta_settings.ruolo_da_chiamare;
    },
    showPasso() {
      return (
        !this.mode_assegna &&
        this.asta_settings.ch_mode == Constants.CHOOSER_MODE.MANUAL_PASSO
      );
    },
    ruoli_da_chiamare() {
      let output = [];
      for (const ruolo of Object.values(Constants.RUOLI_NEW)) {
        const ruolo_id = ruolo.ruolo_id;
        const ruolo_da_chiamare = this.asta_settings.ruolo_da_chiamare;
        if (
          ruolo_da_chiamare == Constants.RUOLO_DA_CHIAMARE.QUALUNQUE ||
          ruolo_da_chiamare == ruolo_id
        ) {
          output.push(ruolo_id);
        }
      }
      return output;
    },
    ...Vuex.mapGetters(["svincolati", "asta_choosers"]),
  },
};
</script>
<style lang="scss" scoped>
/* .random-options .cal-ruoli {
  margin: 5px;
} */
.Ruolo {
  width: 30px;
  height: 30px;
}
.ruolo-mantra {
  cursor: pointer;
  margin: 3px;
  padding: 5px 15px;
  font-size: 14px;
  &:not(.disalibitato):hover {
    opacity: 0.7;
  }
}
.disalibitato {
  opacity: 0.3;
  cursor: default;
}
</style>
